import useSWR from 'swr'
import useSWRMutation from 'swr/mutation'

import { useCallMutation } from '@/common/api/client'
import { fetchRest } from '@/common/api/fetcher'
import {
  GetUploadLogResponse,
  GetUploadLogVars,
  ListUploadLogsResponse,
  ListUploadLogsVars,
  RetryUploadResponse,
  RetryUploadVars,
  UploadApiPath,
  UploadCsvManualResponse
} from '@/common/api/params/upload'

export const useUploadLogsApi = (vars: ListUploadLogsVars) => {
  return useSWR<ListUploadLogsResponse, Response, [string, ListUploadLogsVars]>([
    UploadApiPath.LIST_UPLOAD_LOGS,
    vars
  ])
}

// 詳細（error_details付き）。vars が null の間は取得しない（モーダルを開いた時のみ取得）。
export const useUploadLogDetailApi = (vars: GetUploadLogVars | null) => {
  return useSWR<GetUploadLogResponse, Response, [string, GetUploadLogVars] | null>(
    vars ? [UploadApiPath.GET_UPLOAD_LOG, vars] : null
  )
}

export const useRetryUploadApi = (options?: {
  onSuccess?: (response: RetryUploadResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<RetryUploadResponse, RetryUploadVars>(UploadApiPath.RETRY_UPLOAD, {
    ...options
  })
}

export interface UploadManualVars {
  site_id: number
  master_type: string
  file: File
}

const uploadManualFetcher = async (
  path: string,
  { arg }: { arg: UploadManualVars }
): Promise<UploadCsvManualResponse> => {
  const resolvedPath = path.replace('{site_id}', String(arg.site_id))
  const formData = new FormData()
  formData.append('file', arg.file)
  return fetchRest<UploadCsvManualResponse>(`${resolvedPath}?master_type=${arg.master_type}`, {
    method: 'POST',
    body: formData
  })
}

export const useUploadManualApi = () => {
  return useSWRMutation<UploadCsvManualResponse, Response, string, UploadManualVars>(
    UploadApiPath.UPLOAD_CSV_MANUAL,
    uploadManualFetcher
  )
}
